import PageRoot from './PageRoot.jsx';

export default PageRoot;


// WEBPACK FOOTER //
// ./src/components/PageRoot/index.jsx